var React = require('react');

function Th (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#f4f5f8","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#2d2a4a","d":"M0 162.5h640v160H0z","key":1}),React.createElement("path",{"fill":"#a51931","d":"M0 0h640v82.5H0zm0 400h640v80H0z","key":2})]));
}

Th.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Th;

Th.default = Th;
